import React, {Component} from 'react';
import './header.scss';
import tools from './../../utils/tools';
import {NavLink} from "react-router-dom";
import logo from './../../assets/logo.png';
import icon1 from './../../assets/header/icon-1.png';
import icon2 from './../../assets/header/icon-2.png';
import icon3 from './../../assets/header/icon-3.png';
import icon4 from './../../assets/header/icon-4.png';
import icon5 from './../../assets/header/icon-5.png';
import icon6 from './../../assets/header/icon-6.png';
import icon7 from './../../assets/header/icon-7.png';
import icon1_active from './../../assets/header/icon-1-a.png';
import icon2_active from './../../assets/header/icon-2-a.png';
import icon3_active from './../../assets/header/icon-3-a.png';
import icon4_active from './../../assets/header/icon-4-a.png';
import icon5_active from './../../assets/header/icon-5-a.png';
import icon6_active from './../../assets/header/icon-6-a.png';
import icon7_active from './../../assets/header/icon-7-a.png';
import bg1 from './../../assets/header/bg-1.png';
import bg2 from './../../assets/header/bg-2.png';
import bg3 from './../../assets/header/bg-3.png';
import $ from 'jquery';


class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            scroll: false,
            bottom: false,
            cur_pathname: '',
            navTree: [
                {
                    icon: icon1,
                    icon_active: icon1_active,
                    url: '/index',
                    label: '首页'
                },
                {
                    icon: icon2,
                    icon_active: icon2_active,
                    url: '/404',
                    label: '新闻活动',
                    children: [
                        {
                            url: '/404',
                            label: '公司新闻',
                        },
                        {
                            url: '/404',
                            label: '媒体报道',
                        },
                        {
                            url: '/404',
                            label: '活动信息',
                        },
                        {
                            url: '/404',
                            label: '招标信息',
                        },
                    ],
                },
                {
                    icon: icon3,
                    icon_active: icon3_active,
                    url: '/product/art',
                    label: '产品中心',
                    children: [
                        {
                            url: '/product/art',
                            label: '艺术系列',
                        },
                        {
                            url: '/404',
                            label: '老酒系列',
                        },
                        {
                            url: '/404',
                            label: '舍得系列',
                        },
                        {
                            url: '/404',
                            label: '沱牌系列',
                        },
                        {
                            url: '/404',
                            label: '天子呼',
                        },
                        {
                            url: '/404',
                            label: '陶醉系列',
                        },
                        {
                            url: '/404',
                            label: '舍之道',
                        },
                        {
                            url: '/404',
                            label: '吞之乎',
                        },
                        {
                            url: '/404',
                            label: '专属定制',
                        },
                    ],
                },
                {
                    icon: icon4,
                    icon_active: icon4_active,
                    url: '/journey/temp',
                    label: '智慧之旅',
                    children: [
                        {
                            url: '/journey/temp',
                            label: '舍得艺术中心',
                        },
                        {
                            url: '/404',
                            label: '舍得博物馆',
                        },
                        {
                            url: '/404',
                            label: '泰安作坊',
                        },
                        {
                            url: '/404',
                            label: '生态陈藏',
                        },
                    ],
                },
                {
                    icon: icon5,
                    icon_active: icon5_active,
                    url: '/404',
                    label: '文化国酒',
                    children: [
                        {
                            url: '/404',
                            label: '中国酒文化',
                        },
                        {
                            url: '/404',
                            label: '大国芬芳',
                        },
                        {
                            url: '/404',
                            label: '舍得智慧人物',
                        },
                        {
                            url: '/404',
                            label: '舍得艺术中心',
                        },
                        {
                            url: '/404',
                            label: '舍得博物馆',
                        },
                    ],
                },
                {
                    icon: icon6,
                    icon_active: icon6_active,
                    url: '/404',
                    label: '服务中心',
                    children: [
                        {
                            url: '/404',
                            label: '打假维权',
                        },
                        {
                            url: '/404',
                            label: '招商信息',
                        },
                    ],
                },
                {
                    icon: icon7,
                    icon_active: icon7_active,
                    url: '/404',
                    label: '关于我们',
                    children: [
                        {
                            url: '/404',
                            label: '公司介绍',
                        },
                        {
                            url: '/404',
                            label: '加入我们',
                        },
                        {
                            url: '/404',
                            label: '廉洁文化',
                        },
                        {
                            url: '/404',
                            label: '联系我们',
                        },
                    ],
                },
            ],
        };

    }

    componentWillMount() {

    }

    componentDidMount() {
        window.addEventListener('scroll', this.bindScroll.bind(this))

        console.log(this.props.location.pathname)
        this.setState({
            cur_pathname: this.props.location.pathname,
        })
    }


    componentWillUnmount() {

    }

    // shouldComponentUpdate() {
    //
    // }

    render() {
        const {navTree, cur_pathname} = this.state;

        return (
            <header className={"header " + (this.state.scroll ? 'scroll ' : '') + (this.state.bottom ? 'bottom' : '')}
                    style={{backgroundImage: `url(${this.getBg()})`}}>
                <div className="header-container">
                    <div className="header-inner">
                        <div className="header-logo">
                            <img src={logo} alt=""/>
                        </div>
                        <nav className="header-nav">
                            <ul className="nav-menu">
                                {
                                    navTree.map((item, index) => {
                                        return <li
                                            className={"nav-item " + (item.url == cur_pathname ? 'active' : '')}
                                            key={index}>
                                            <NavLink to={item.url}>
                                                <div className="nav-item-icon">
                                                    <img src={item.url == cur_pathname ? item.icon_active : item.icon}
                                                         alt=""/>
                                                </div>
                                            </NavLink>

                                            {
                                                item.children && item.children.length > 0  ?
                                                    <ul className={"nav-sub "+(item.url == cur_pathname?'open':'')}>
                                                        {
                                                            item.children.map((subItem, subIndex) => {
                                                                return <NavLink to={subItem.url}
                                                                                className={"nav-sub-item " + (subItem.url == cur_pathname ? 'active' : '')}
                                                                                key={subIndex}>
                                                                    <li>{subItem.label}</li>
                                                                </NavLink>
                                                            })
                                                        }
                                                    </ul>
                                                    : ''
                                            }
                                        </li>
                                    })
                                }

                            </ul>
                        </nav>
                    </div>
                </div>
            </header>
        );
    }

    getBg() {
        const {cur_pathname} = this.state;
        if (cur_pathname == '/index') {
            return bg1
        } else if (cur_pathname.indexOf('/product') > -1) {
            return bg2
        } else if (cur_pathname.indexOf('/journey') > -1) {
            return bg3
        }else {
            return bg1
        }
    }

    isActive(url) {
        const {cur_pathname} = this.state;
        if (cur_pathname == '/') {
            if (url == '/' || url == '/index') {
                return true
            } else {
                return false
            }
        } else {
            if (cur_pathname.indexOf(url) >= 0) {
                console.log(url + '  ' + cur_pathname)
                return true
            } else {
                return false
            }
        }
    }

    bindScroll(event) {
        // // 滚动的高度
        // const scrollTop = (event.srcElement ? event.srcElement.documentElement.scrollTop : false) || window.pageYOffset || (event.srcElement ? event.srcElement.body.scrollTop : 0);
        // // // 视窗高度
        // const clientHeight = (event.srcElement && event.srcElement.documentElement.clientHeight) || document.body.clientHeight;
        // // // 页面高度
        // const scrollHeight = (event.srcElement && event.srcElement.documentElement.scrollHeight) || document.body.scrollHeight;
        const scrollTop = window.pageYOffset;
        // // 视窗高度
        const clientHeight = document.body.clientHeight;
        // // 页面高度
        const scrollHeight = document.body.scrollHeight;
        // // 距离页面底部的高度
        const height = scrollHeight - scrollTop - clientHeight;


        // 判断距离页面底部的高度
        if (scrollTop > 800) {
            this.setState({
                scroll: true
            })
        } else {
            this.setState({
                scroll: false
            })
        }

        // 判断距离页面底部的高度
        if (height < tools.transWidth(460)) {
            this.setState({
                bottom: true
            })
        } else {
            this.setState({
                bottom: false
            })
        }
    }

}

export default Header;


// WEBPACK FOOTER //
// ./src/pages/Index/index.js
